import { PcCase, Laptop, Tablet, Smartphone, Monitor, Tv, Headphones, Wifi, Cctv, House, Wrench, BatteryCharging, Gamepad2, Cable, Refrigerator } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const cats = [
  { icon: PcCase, name: "Computadoras" },
  { icon: Laptop, name: "Laptops" },
  { icon: Tablet, name: "Tablets" },
  { icon: Smartphone, name: "Celulares" },
  { icon: Monitor, name: "Monitores" },
  { icon: Tv, name: "Pantallas" },
  { icon: Headphones, name: "Audio" },
  { icon: Wifi, name: "Redes" },
  { icon: Cctv, name: "Seguridad" },
  { icon: House, name: "Smart Home" },
  { icon: Wrench, name: "Herramientas" },
  { icon: BatteryCharging, name: "Energía" },
  { icon: Gamepad2, name: "Gaming" },
  { icon: Cable, name: "Accesorios" },
  { icon: Refrigerator, name: "Línea blanca" },
];

export default function Categories() {
  return (
    <section id="categorias" className="relative py-24 md:py-36 bg-ecdeep overflow-hidden" data-testid="categories-section">
      <div className="absolute -top-32 right-0 h-[420px] w-[420px] rounded-full bg-ecamber/10 blur-[130px]" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          num="04"
          chapter="Categorías"
          id="categorias"
          dark
          title={<>Quince categorías, <span className="text-ecamber">un solo proveedor</span></>}
          sub="Consolide su abastecimiento tecnológico completo con eClick México."
        />
        <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
          {cats.map((c, i) => (
            <Reveal key={c.name} delay={(i % 5) * 0.06} y={28}>
              <div
                className="group h-full rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-7 flex flex-col items-start gap-5 transition-colors duration-300 hover:bg-white/[0.09] hover:border-ecamber/50 cursor-default"
                data-testid={`category-card-${i}`}
              >
                <span className="inline-flex h-12 w-12 rounded-xl bg-ecamber/15 text-ecamber items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6">
                  <c.icon size={24} strokeWidth={1.9} />
                </span>
                <span className="font-display text-base font-medium text-white">{c.name}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
